import { TvStaticData } from 'app/page/orders/static/tv-static-data';
import { ShoppingCartMapper } from 'app/page/orders/mapper/shopping-cart-mapper';

export class TvMapper {
    public static getAvailableTvOffers(
        shoppingCart: OrderTrackerBackend.ShoppingCart,
    ): OrderTrackerBackend.ProductOffering[] {
        return shoppingCart.productOfferings
            .filter((offer) => offer.available)
            .filter((offer) => offer.name === TvStaticData.TV_OFFER_NAME);
    }

    public static findSelectedTvOffer(
        shoppingCart: OrderTrackerBackend.ShoppingCart,
    ): OrderTrackerBackend.ProductOffering | undefined {
        const selected: OrderTrackerBackend.ProductOffering[] = TvMapper.getAvailableTvOffers(shoppingCart).filter(
            (offer) => ShoppingCartMapper.findProduct(shoppingCart, offer.name),
        );

        if (selected.length > 1) {
            throw Error('Illegal state, shopping cart cannot contain multiple tv offers');
        }

        return selected[0];
    }

    public static getTvChannelPackages(shoppingCart: OrderTrackerBackend.ShoppingCart): OrderTrackerBackend.Option[] {
        return TvMapper.getTvChannelOptions(shoppingCart).filter(
            (option) => option.category === TvStaticData.TV_PACKAGE_CATEGORY,
        );
    }

    public static getIndividualTvChannels(
        shoppingCart: OrderTrackerBackend.ShoppingCart,
    ): OrderTrackerBackend.Option[] {
        return TvMapper.getTvChannelOptions(shoppingCart).filter(
            (option) =>
                option.category !== TvStaticData.TV_PACKAGE_CATEGORY &&
                option.category !== TvStaticData.TV_STREAMING_CHANNEL_CATEGORY,
        );
    }

    public static getStreamingChannels(shoppingCart: OrderTrackerBackend.ShoppingCart): OrderTrackerBackend.Option[] {
        return TvMapper.getTvChannelOptions(shoppingCart).filter(
            (option) => option.category === TvStaticData.TV_STREAMING_CHANNEL_CATEGORY,
        );
    }

    public static getSelectedTvChannelOptions(
        shoppingCart: OrderTrackerBackend.ShoppingCart,
    ): OrderTrackerBackend.Option[] {
        const selectedTvProduct: OrderTrackerBackend.CartItem | undefined =
            TvMapper.findSelectedTvOfferProduct(shoppingCart);

        if (!selectedTvProduct) {
            return [];
        }

        return TvMapper.getTvChannelOptions(shoppingCart).filter(
            (option) => ShoppingCartMapper.findCharacteristicsByOption(selectedTvProduct, option).length !== 0,
        );
    }

    public static findSelectedTvOfferProduct(
        shoppingCart: OrderTrackerBackend.ShoppingCart,
    ): OrderTrackerBackend.CartItem | undefined {
        const selectedTvOffer: OrderTrackerBackend.ProductOffering | undefined =
            TvMapper.findSelectedTvOffer(shoppingCart);

        return selectedTvOffer && ShoppingCartMapper.findProduct(shoppingCart, selectedTvOffer.name);
    }

    private static getTvChannelOptions(shoppingCart: OrderTrackerBackend.ShoppingCart): OrderTrackerBackend.Option[] {
        return shoppingCart.options.filter(
            (option) =>
                option.name.startsWith(TvStaticData.TV_CHANNEL_PACKAGE_OPTION_PREFIX) ||
                option.name.startsWith(TvStaticData.STREAMING_OPTION_PREFIX),
        );
    }
}
